import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Profile from './views/Profile'
import Configuration from './views/Configuration'
import customer from './views/Customer'
import Users from './views/Users'
import Customers from './views/Customers'
import requests from './views/Requests'
import request from './views/Request_info'
import Add_request from './views/Add_request'
import unsavedRequest from './views/UnsavedRequest'
import Customer_info from './views/Customer_info'
import requestsStatus from './views/RequestsStatus'
import unsavedRequests from './views/unsavedRequests'
import NotFound from './views/NotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: 'requests',
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
  {
      path: '/configuration',
      name: 'configuration',
      component: Configuration
  },
      {
          path: '/users',
          name: 'users',
          component: Users
      },
      {
          path: '/customers',
          name: 'customers',
          component: Customers
      },
      {
          path: '/customers/:id',
          name: 'customer_info',
          component: Customer_info
      },
      {
          path: '/requests',
          name: 'requests',
          component: requests
      },
      {
          path: '/add_request/:id',
          name: 'add_request',
          component: Add_request
      },
      {
          path: '/unsavedRequest/:id',
          name: 'unsavedRequest',
          component: unsavedRequest
      },
      {
          path: '/requests/:id',
          name: 'request',
          component: request
      },
      {
          path: '/requestsStatus',
          name: 'requestsStatus',
          component: requestsStatus
      },
      {
          path: '/customer',
          name: 'customer',
          component: customer
      },
      {
          path: '/unsavedRequests',
          name: 'unsavedRequests',
          component: unsavedRequests
      },
  ],

})

router.beforeEach((to, from, next) => {
    if(to.path != '/login') {
        if(localStorage.getItem('token')) {
            next();
        } else {
            next('login');
        }
    } else {
        next();
    }
});

export default router